'use client';
import React, { useState } from 'react';
import get from 'lodash/get';
import { useRouter } from 'next/navigation';
import { BASE_FILE_URL } from '@/common/constants';
import { useTranslations } from 'next-intl';
import { CalendarOutlined, DownloadOutlined, EyeOutlined } from '@ant-design/icons';
import { formatDateVN } from '@/common/ultils';
const DraftItem = ({ item, onViewAll, onDownload, onViewComments, onSendComments }) => {
  const t = useTranslations('');
  return (
    <div className="flex items-start py-3 border-b border-gray-100 last:border-b-0">
      <div className="flex-1 min-w-0">
        <div className="flex justify-between">
          <div className=" w-8/12">
            <span className=" text-sm text-[#000] boldish-text mb-2 line-clamp-4 h-[40px] pr-2">{item.title || item.name}</span>

            <div className="flex items-center text-sm text-gray-500">
              <CalendarOutlined className="mr-1" />
              <span>{formatDateVN(item?.date)}</span>
            </div>
          </div>
          <div className="w-4/12 flex flex-col justify-end">
            <button
              onClick={() => onViewAll && onViewAll(item)}
              className="inline-flex items-center px-4 py-2 text-sm font-medium bg-white border border-gray-200
                      text-[#02B8FA]  rounded-lg hover:bg-blue-100 transition-colors cursor-pointer">
              <EyeOutlined className="w-3 h-3 mr-2" />
              <span className="text-xs">{t('draftCmt.viewAll')}</span>
            </button>
            <button
              onClick={() => onDownload && onDownload(item)}
              className="inline-flex items-center px-4 py-2 text-sm font-medium mt-2 border border-gray-200
                    text-gray-600  rounded-lg hover:bg-gray-100 transition-colors cursor-pointer">
              <DownloadOutlined className="w-3 h-3 mr-2" />
              <span className="text-xs">{t('draftCmt.download')}</span>
            </button>
            <div className="flex items-center space-x-4 text-xs mt-2">
              <div className="mt-1">
                <button onClick={() => onViewComments && onViewComments(item)} className="text-[11px] text-[#02B8FA] hover:underline cursor-pointer">
                  {t('draftCmt.viewComments')}
                </button>
                <span className="text-xs text-gray-400 mx-1">|</span>
                <button onClick={() => onSendComments && onSendComments(item)} className="text-[11px] text-[#02B8FA] hover:underline cursor-pointer">
                  {t('draftCmt.sendCmt')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
const DraftDocument = ({ websiteCode, draftDocuments }) => {
  const router = useRouter();
  const t = useTranslations('');
  const [openCollapseList, setOpenCollapseList] = useState(false);
  const dataDraftProposals = get(draftDocuments, 'results', []);

  const handleViewAll = (item) => {
    if (websiteCode) {
      router.push(`/sub/${websiteCode}/du-thao/${item?.slug}`);
    } else {
      router.push(`/du-thao/${item?.slug}`);
    }
    // Add your view all logic here
  };

  const handleDownload = (item) => {
    setOpenCollapseList(item?.id);
  };

  const handleViewComments = (item) => {
    if (websiteCode) {
      router.push(`/sub/${websiteCode}/du-thao/${item?.slug}/phan-hoi`);
    } else {
      router.push(`/du-thao/${item?.slug}/phan-hoi`);
    }
    // Add your view comments logic here
  };

  const handleSendComments = (item) => {
    if (websiteCode) {
      router.push(`/sub/${websiteCode}/du-thao/${item?.slug}`);
    } else {
      router.push(`/du-thao/${item?.slug}`);
    }
    // Add your send comments logic here
  };
  return (
    <div className="border border-[#0000000f] rounded  bg-white w-full lg:w-[49.3%] vb-moi relative">
      <div className="title">
        <a href={`${t('home.linkTo')}`} className="font-normal">
          {t('home.titleDraft')}
        </a>
      </div>

      <div className="pb-2">
        <div className="space-y-1 px-2">
          {dataDraftProposals.map((item) => (
            <React.Fragment key={item.id}>
              <DraftItem
                item={item}
                onViewAll={handleViewAll}
                onDownload={handleDownload}
                onViewComments={handleViewComments}
                onSendComments={handleSendComments}
              />
              <div
                className={`transition-all duration-300 ease-in-out overflow-hidden ${
                  openCollapseList === item?.id ? 'max-h-[1000px] mt-4' : 'max-h-0'
                }`}>
                <ul className="space-y-2">
                  {item?.fileUrls?.length === 0 ? (
                    <li className="text-sm text-gray-500">{t('draftCmt.noFileDocument')}</li>
                  ) : (
                    item?.fileUrls?.map((file) => {
                      return (
                        <li key={file} className="p-3 bg-gray-100 rounded-md hover:bg-gray-200 space-y-2">
                          <div className="flex items-center justify-between">
                            <span className="text-sm text-gray-800 truncate max-w-62.5">{(file ?? "").split("/").pop()}</span>
                            <div className="flex items-center space-x-3">
                              <a
                                href={`${BASE_FILE_URL}/${file}`}
                                download
                                className="inline-flex items-center text-blue-600 hover:underline text-sm cursor-pointer">
                                <DownloadOutlined className="mr-1" /> {t('draftCmt.download')}
                              </a>
                            </div>
                          </div>
                        </li>
                      );
                    })
                  )}
                </ul>
              </div>
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DraftDocument;
